import { getRelativeTime } from '@/utils/common'

export class Notification {
  id = null
  header = ''
  htmlText = null
  notificationType = null
  viewed = false
  createdAt = null
  createdAvatarUrl = null
  linkInfo = {}
  createdByName = null

  constructor(origin) {
    if (!origin) return
    this.id = origin.id
    this.header = origin.header
    this.htmlText = origin.html_text
    this.notificationType = origin.notification_type
    this.viewed = origin.viewed
    this.createdAvatarUrl = origin.created_avatar_url
    this.linkInfo = origin.link_info
    // Handle date parsing with error handling
    if (origin.created_at) {
      try {
        const parsedDate = new Date(origin.created_at)
        if (isNaN(parsedDate.getTime())) {
          console.warn('Invalid date format in activity notification:', origin.created_at, 'for notification:', origin.id)
          this.createdAt = 'recently'
        } else {
          this.createdAt = getRelativeTime(parsedDate).toLowerCase()
        }
      } catch (error) {
        console.warn('Error parsing date in activity notification:', origin.created_at, error, 'for notification:', origin.id)
        this.createdAt = 'recently'
      }
    } else {
      this.createdAt = 'recently'
    }
    // Handle both created_by_name string and created_by object (for backward compatibility)
    if (origin.created_by_name) {
      this.createdByName = origin.created_by_name
    } else if (origin.created_by && typeof origin.created_by === 'object') {
      this.createdByName = origin.created_by.name || origin.created_by.email || 'Unknown'
    } else {
      this.createdByName = 'Unknown'
    }
  }
}
